import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ReCAPTCHA from 'react-google-recaptcha';
import { Button, LinkButton, EnProgresoSVG } from 'common-ui-components';
import { selectConfig } from '../../redux/selectors';
import { navigateTo } from '../../redux/Slice/navigationSlice';
import { NumericInput } from '../../components/NumericInput';
import { checkProcessStatus } from '../../redux/Slice/promoterSlice';

const CheckStatusScreen = () => {
  const {
    language: {
      checkStatusScreen: text
    },
    configs: { recaptchaSiteKey }
  } = useSelector(selectConfig);
  const dispatch = useDispatch();
  const [captchaToken, setCaptchaToken] = useState('');
  const [inputValue, setInputValue] = useState('');

  const handleSubmit = async () => {
    try {
      const response = await dispatch(checkProcessStatus({
        processId: inputValue,
        token: captchaToken
      })).unwrap();
      if (response?.status !== '200') {
        throw new Error('Trámite inexistente');
      }
      dispatch(navigateTo('ProcessingApplication'));
    } catch (error) {
      switch (error?.errorCode) {
        case '100007':
          dispatch(navigateTo('CancelledApplication'));
          break;
        case '100008':
          dispatch(navigateTo('ServiceSuccess'));
          break;
        case '100009':
          dispatch(navigateTo('InvalidApplicationNumber'));
          break;
        default:
      }
    }
  }

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  }

  const handleBackButton = (e) => {
    e.preventDefault();
    dispatch(navigateTo('Promoter'));
  }

  return (
    <section className='section checkStatus-final'>
      <EnProgresoSVG
        style={{ display: 'block', overflow: 'visible', width: '100%' }}
        transparent
        noMargin
      />
      <h2 className='checkStatus-title'>{text.title}</h2>
      <div className='checkStatus-final-details'>
        <NumericInput
          id='checkStatus-input'
          className='checkStatus-input'
          label={text.inputLabel}
          labelText={text.inputPlaceholder}
          onChange={handleInputChange}
          value={inputValue}
          data-testid='checkStatus-input'
        />

        <ReCAPTCHA
          sitekey={recaptchaSiteKey || ''}
          onChange={setCaptchaToken}
        />

        <Button
          data-testid='checkStatus-submit-button'
          className='submit-button-error checkStatus-button'
          onClick={handleSubmit}
          disabled={!captchaToken || !inputValue}
        >
          {text.primaryButton}
        </Button>
        <LinkButton
          data-testid='checkStatus-back-button'
          className='checkStatus-link-button'
          onClick={handleBackButton}
        >
          {text.secondaryButton}
        </LinkButton>

      </div>
    </section>
  );
};

export default CheckStatusScreen;